exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-gratuity .custom-label--nowrap{white-space:nowrap;word-break:normal;word-wrap:normal}\n", ""]);

